<template>
  <partner-card :id="id"/>
</template>

<script>
import PartnerCard from '@/components/app/partners/PartnerCard'

export default {
  name: "Partner",
  components: {
    PartnerCard
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    isCreating() {
      return this.id === 'create'
    },
    isShowing() {
      return !this.isCreating
    }
  },
}
</script>

<style scoped>

</style>